import ServicePage from "../components/site/ServicePage";
import { getService } from "../data/site";

const TASKS = [
  "Groceries",
  "Refrigerator stocking",
  "Pantry stocking",
  "Beverages",
  "Everyday essentials",
  "Toiletries",
  "Paper goods",
  "Fresh flowers",
  "Beach supplies",
  "Children's items",
  "Special requests",
];

export default function VacationRestocking() {
  return (
    <ServicePage
      service={getService("vacation-restocking")}
      tagline="Arrive and start relaxing."
      intro="Skip the grocery run after a long drive. We stock your vacation home before you arrive — fridge full, coffee ready, flowers on the counter, beach bags by the door — so your time off starts the moment you walk in. Shopping is billed separately at cost."
      tasksTitle="We can stock it all"
      tasks={TASKS}
      quoteHeading="Request a Quote"
    />
  );
}
